import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const KEY = 'msld.token';
function read(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

const slice = createSlice({
  name: 'auth',
  initialState: { token: read() as string | null },
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
      try {
        sessionStorage.setItem(KEY, action.payload);
      } catch {
        /* storage unavailable — session lasts for this tab only */
      }
    },
    logout(state) {
      state.token = null;
      try {
        sessionStorage.removeItem(KEY);
      } catch {
        /* ignore */
      }
    },
  },
});

export const { setToken, logout } = slice.actions;
export default slice.reducer;
